import { FormSectionLayout } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { useRouteParams } from "src/hooks/useRouteParams";
import { ProjectParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";
import {
  SelectConfigurationStep_StructureFragment,
  useSelectConfigurationStepQuery,
} from "./1.SelectConfigurationStep.generated";
import { ApplyConfigurationFormInput } from "./applyConfigurationForm";
import { ConfigurationChangeSection } from "./components/ConfigurationChangeSection";

type SelectConfigurationStepProps = { formState: ObjectState<ApplyConfigurationFormInput> };

export function SelectConfigurationStep(props: SelectConfigurationStepProps) {
  const { formState } = props;
  const { projectId } = useRouteParams<ProjectParams>();
  const query = useSelectConfigurationStepQuery({ variables: { structureId: projectId } });
  return queryResult(query, ({ structure }) => (
    <SelectConfigurationStepView formState={formState} structure={structure} />
  ));
}

type SelectConfigurationStepViewProps = SelectConfigurationStepProps & {
  structure: SelectConfigurationStep_StructureFragment;
};

function SelectConfigurationStepView(props: SelectConfigurationStepViewProps) {
  const { formState, structure } = props;

  return (
    <FormSectionLayout
      title="Select the Configuration to Apply"
      description="Choose a reserved Checkout configuration to replace the current configuration on this structure."
      sections={[
        {
          title: "Configuration Change",
          fields: <ConfigurationChangeSection formState={formState} structure={structure} />,
        },
      ]}
    />
  );
}
